module.exports = __webpack_public_path__ + "static/new-stack-40824617b79f80826bd727a1db95d8e7.png";